import { render, staticRenderFns } from "./OrderCustomerEmployeesConfirmResgister.vue?vue&type=template&id=87d5f89c&scoped=true&"
import script from "./OrderCustomerEmployeesConfirmResgister.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerEmployeesConfirmResgister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d5f89c",
  null
  
)

export default component.exports